import api from "../../config/apiConfig";
import { UserDetails,RMUserDetails} from "../../models/user.model";
import { UserId } from "../../models/userId.model";


const getUser = async (data: any) => {
    const accessToken = localStorage.getItem("accessToken");
    const response = await api.post("/admin/getAllUsers", data, {
        headers: {
            Authorization: accessToken, // Ensure the token is formatted correctly
        },
    });
    return response.data;
};

const getRMUser = async (data: RMUserDetails) => {
  const accessToken = localStorage.getItem("accessToken");
  const response = await api.post("admin/getAllRm", data, {
      headers: {
          Authorization: accessToken, // Ensure the token is formatted correctly
      },
  });
  return response.data;
};

const getAllUserForRM = async (data: RMUserDetails) => {
  const accessToken = localStorage.getItem("accessToken");
  const response = await api.post("admin/rm/getAllUsers", data, {
      headers: {
          Authorization: accessToken, // Ensure the token is formatted correctly
      },
  });
  return response.data;
};

//get user detail by id
const getUserById = async (data:UserId) => {
    const accessToken = localStorage.getItem("accessToken");
    const response = await api.post(
      "/user/getById", data, {
        headers: {
          Authorization: accessToken,
        },
      });
    return response.data;
  };

// download user data
const downloadUserData = async (data: any) => {
    const accessToken = localStorage.getItem("accessToken");
    const response = await api.post("/admin/downloadUserData", data, {
        headers: {
            Authorization: accessToken, // Ensure the token is formatted correctly
        },
    });
    return response.data;
};

const updateUser = async (data: FormData) => {
    const accessToken = localStorage.getItem("accessToken");
    const response = await api.post("/user/update", data, {
      headers: {
        Authorization: accessToken,
        'Content-Type': 'multipart/form-data', // Ensure the header is set for form data
      },
    });
    return response.data;
  };

const registerUser = async (data: any) => {
    const accessToken = localStorage.getItem("accessToken");
    const response = await api.post("/admin/registerUser", data, {
      headers: {
        Authorization: accessToken,
        'Content-Type': 'multipart/form-data', // Ensure the header is set for form data
      },
    });
    return response.data;
  };

  const registerRMUser = async (data: any) => {
    const accessToken = localStorage.getItem("accessToken");
    const response = await api.post("admin/registerRM", data, {
      headers: {
        Authorization: accessToken,
      },
    });
    return response.data;
  };

  const registerPartnerUser = async (data: any) => {
    const accessToken = localStorage.getItem("accessToken");
    const response = await api.post("admin/addPartner", data, {
      headers: {
        Authorization: accessToken,
      },
    });
    return response.data;
  };

  const updatePassword = async (data: any) => {
    const accessToken = localStorage.getItem("accessToken");
    const response = await api.post(
      "/user/changePassword",
      data,
      {
        headers: {
          Authorization: accessToken,
        },
      }
    );
    return response.data;
  };

  const updateProfile = async (data: any) => {
    const accessToken = localStorage.getItem("accessToken");
    const response = await api.post(
      "user/update",
      data,
      {
        headers: {
          Authorization: accessToken,
        },
      }
    );
    return response.data;
  };

  const getPricingDetails = async (data:any) => {
    const accessToken = localStorage.getItem("accessToken");
    const response = await api.post(
      "admin/GetBrockerageLog", data, {
        headers: {
          Authorization: accessToken,
        },
      });
    return response.data;
  };

  const addPricingDetails = async (data: any) => {
    const accessToken = localStorage.getItem("accessToken");
    const response = await api.post(
      "admin/addBrockerageLog",
      data,
      {
        headers: {
          Authorization: accessToken,
        },
      }
    );
    return response.data;
  };

  const updatePricingDetails = async (data: any) => {
    const accessToken = localStorage.getItem("accessToken");
    const response = await api.post(
      "admin/updateBrockerageLog",
      data,
      {
        headers: {
          Authorization: accessToken,
        },
      }
    );
    return response.data;
  };


  const verifyPan = async (data: any) => {
    const response = await api.post(
      "/user/panVerify",
      data
    );
    return response.data;
  };
  
  const sendRegisterOtp = async (data: any) => {
    const response = await api.post(
      "/user/signUp",
      data
    );
    return response.data;
  };

const sendResetPasswordLink = async (data: FormData) => {
  const accessToken = localStorage.getItem("accessToken");
  const response = await api.post("/admin/sendPasswordLink", data, {
    headers: {
      Authorization: accessToken,
    },
  });
  return response.data;
};

const resetPassword = async (data: any, token: string) => {
  const response = await api.post("/user/resetPassword", data, {
    headers: {
      Authorization: token,
    },
  });
  return response.data;
};


  const getPartnerLogUsers = async (data: any) => {
    const accessToken = localStorage.getItem("accessToken");
    const response = await api.post(
      "admin/getPartnerLogUsers",
      data,
      {
        headers: {
          Authorization: accessToken,
        },
      }
    );
    return response.data;
  };

const userService = { getUser, downloadUserData, updateUser, getUserById,registerPartnerUser, registerUser,getRMUser ,registerRMUser,getAllUserForRM,updatePassword,updateProfile, getPricingDetails, addPricingDetails, updatePricingDetails, getPartnerLogUsers, verifyPan, sendRegisterOtp, sendResetPasswordLink, resetPassword };
export default userService;
